import { useEffect, useRef, useState } from 'react';

function CountUp({ end, duration = 2, suffix = '', startWhen = false }) {
  const [value, setValue] = useState(0);
  const ref = useRef();
  useEffect(() => {
    if (!startWhen) return;
    let start = 0;
    let startTime = null;
    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / (duration * 1000), 1);
      const current = Math.floor(progress * (end - start) + start);
      setValue(current);
      if (progress < 1) {
        ref.current = requestAnimationFrame(animate);
      } else {
        setValue(end);
      }
    };
    ref.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(ref.current);
  }, [end, duration, startWhen]);
  return <span>{value}{suffix}</span>;
}

export default CountUp; 